// extracted by mini-css-extract-plugin
module.exports = {"sboutServiceCarouselContainer":"style_sboutServiceCarouselContainer__Fr7uh","sboutServiceCarouselSlide":"style_sboutServiceCarouselSlide__P9aeF"};